import _slicedToArray from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { debugLog } from "../logger";

var parseResponseHeaders = function parseResponseHeaders(xhr) {
  var resHeaders;

  try {
    resHeaders = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/).reduce(function (res, line) {
      var _line$split = line.split(": "),
          _line$split2 = _slicedToArray(_line$split, 2),
          key = _line$split2[0],
          val = _line$split2[1];

      res[key] = val;
      return res;
    }, {});
  } catch (ex) {
    debugLog("uploady.request: failed to read response headers", xhr);
  }

  return resHeaders;
};

export default parseResponseHeaders;